import { parse } from "./DateTimeUtils";

/**
 * Check if an option has green delivery day which is
 * the same as currentDate.
 * @param currentDate - date to check if it is green for
 * given option
 * @param option - webshop shipping option
 * @returns true if currentDate is green or false if not
 */
export const isDateGreenForOption = (currentDate, option) => {
    const deliveryDates = option?.deliveryDates;

    return isDateGreen(currentDate, deliveryDates);
};

/**
 * Check if deliveryDates has at least one green delivery day
 * which is the same as currentDate.
 * @param currentDate - date to check if it is green for
 * given deliveryDates
 * @param deliveryDates - delivery dates
 * @returns true if currentDate is green or false if not
 */
export const isDateGreen = (currentDate, deliveryDates) => {
    const greenDeliveryDates = deliveryDates?.filter(deliveryDayIsGreen());
    return !!findGreenDate(greenDeliveryDates, currentDate);
};

export const findGreenDate = (greenDeliveryDates, currentDate) => {
    return greenDeliveryDates?.find(d => {
        const greenDate = parse(d.deliveryDate);

        return greenDate.getTime() === currentDate.getTime();
    });
};

/**
 * Check if at least one option exists which has at least one
 * green delivery day.
 * @param options - webshop shipping options
 * @returns true if green option present or false if not
 */
export const hasOptionWithGreenDate = (options = []) => {
    return !!options.find(o => {
        return !!o.deliveryDates?.find(deliveryDayIsGreen());
    });
};

/**
 * Search green delivery dates.
 * @param deliveryDates - dates to search green dates
 * @returns delivery dates which are green
 */
export const findGreenDeliveryDates = (deliveryDates = []) =>
    deliveryDates?.filter(deliveryDayIsGreen());

const deliveryDayIsGreen = () => d => d.rateReason === 'GREEN' && (!!d.rate || d.rate === 0);

export const getPrice = (option, currentDate) => {
    const greenDeliveryDates = findGreenDeliveryDates(option.deliveryDates);
    const currentGreenDate = findGreenDate(greenDeliveryDates, currentDate);

    if (!currentGreenDate) {
        return option.rate || 0;
    }

    return currentGreenDate.rate;
};